import React from 'react';
import { CollectionFee } from '../components';

export default () => {
    return (
        <CollectionFee.Home />
    )
}